module.exports = __webpack_public_path__ + "e0e72dea34037bf6e706400ac4571ba1.otf";